import { SelectField } from "$components/rhf-fields";
import { TERRITORY } from "$routes/_lib/constants";
import useCountryTranslation from "$routes/new/_lib/use-country-translation";
import { useTerritoryCode } from "$routes/new/_lib/use-territory";
import { useMemo } from "react";

function capitalizeFirstChar(str) {
  return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
}

function getCountriesWeOperate(countries, clinicCountry) {
  return countries.filter(
    (c) =>
      Object.values(TERRITORY).map(capitalizeFirstChar).includes(c.name) &&
      clinicCountry !== c,
  );
}

function moveTerritoryCountriesToTop(
  clinicCountryCode: string,
  countries: { name: string; code: string }[],
) {
  if (!clinicCountryCode) {
    return countries;
  }

  const clinicCountry = countries.find(
    ({ code }) => code === clinicCountryCode,
  );
  if (!clinicCountry) {
    return countries;
  }

  const topCountries = [clinicCountry].concat(
    getCountriesWeOperate(countries, clinicCountry),
  );

  return topCountries.concat(
    countries.filter((c) => !topCountries.includes(c)),
  );
}

type CountrySelectInputProps = {
  name: string;
  label: string;
  required?: boolean;
};

export const CountrySelectInput = (props: CountrySelectInputProps) => {
  const { countries } = useCountryTranslation();
  const country = useTerritoryCode();

  return (
    <SelectField
      fullWidth
      {...props}
      options={useMemo(
        () =>
          moveTerritoryCountriesToTop(country, countries).map(
            ({ name, code }) => ({ label: name, value: code }),
          ),
        [country, countries],
      )}
    />
  );
};
